export const perUnitNumberPrecision = 4; // per_share applies for this case
export const defaultNumberPrecision = 2;
export const fundingNumberPrecision = 0;

export default {
  perUnitNumberPrecision,
  defaultNumberPrecision,
  fundingNumberPrecision,
};
